/**
 * The Home content column. Every stacked section on the Sofia Home surface —
 * the composer, the insight digest, and the onboarding setup cards — sits in
 * this column, so their left and right edges line up and widening one widens
 * all of them together.
 */
export const HOME_CONTENT_COLUMN =
  "mx-auto w-full max-w-[680px] px-4 xl:max-w-[720px]"
